import { render } from "./ModulatorControl.vue?vue&type=template&id=2e45db07"
import script from "./ModulatorControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulatorControl.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/config-app/components/ModulatorControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e45db07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e45db07', __exports__)) {
    api.reload('2e45db07', __exports__)
  }
  
  module.hot.accept("./ModulatorControl.vue?vue&type=template&id=2e45db07", () => {
    api.rerender('2e45db07', render)
  })

}


export default __exports__